import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconWorldPin } from "@tabler/icons-react";
import { RegionesDef } from "./RegionesDef";

export const RegionesIcon = IconWorldPin;
export const RegionesHelpText = '* Aquí puede ver la lista de todas las regiones disponibles.';

export class Regiones extends Entity<RegionesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RegionesDef(), parentKeys);
        this.Form = import('./RegionesForm').then((module) => module.RegionesForm);
        this.Title = "Regiones";
        this.HelpText = RegionesHelpText;
        this.Icon = RegionesIcon;
    }
}